import { useProfileReviewStore } from '~/stores/profileReviewStore';

/** Loads every review once the user is known to have access to Visibility > My trades (see useProfileReviewAccess). */
export default function useProfileReviewInit(): void {
    const store = useProfileReviewStore();

    watch(
        () => store.access,
        (access) => {
            if (access === 'granted') useWhenTenantReady(() => store.loadAll());
        },
        { immediate: true }
    );
}
